import React, { useState } from "react";

export default function useHover() {
  const [hover, setHover] = useState(false);

  function onMouseEnter() {
    setHover(true);
  }

  function onMouseLeave() {
    setHover(false);
  }

  const props = {
    onMouseEnter,
    onMouseLeave,
  };

  return [hover, props];
}
